import React from 'react';
import cn from 'classnames';
import { Grid } from '@chakra-ui/react';
import { RichText, Image } from 'shared';
import styles from './Awardcard.module.scss';

export type AwardCardProps = {
    className?: string
    years: string[],
    description: any,
    image?: {
        url: string
    }
}

export const AwardCard = ({
    className,
    years,
    description,
    image,
}: AwardCardProps) => (
    <div className={cn(className, styles.awardCard)}>
        <ul className={styles.awardCard__yearsList}>
            {years.map((year) => (
                <li>
                    {year}
                </li>
            ))}
        </ul>
        <Grid
            templateRows="1fr auto"
            gap="1rem"
        >
            <RichText
                fontSize="1rem"
                content={description}
                lineClamp={5}
                color="white"
                textAlign="justify"
            />
            <Image className={styles.awardCard__image} src={image?.url || ''} />
        </Grid>
    </div>
);
